import { defineStore } from 'pinia';
import { GameLotteryListType, NoticeListType, PlatformListType } from 'types/lottery.d';
import { LotteryService } from 'service/lottery';

interface LotteryState {
    platformList: PlatformListType[];
    noticeList: NoticeListType[];
    gameLotteryList: GameLotteryListType[];
    lotteryCarouselList: any[];
    allGameList: any[];
    groupGameList: any[];
}

export const useLotteryStore = defineStore('LotteryStore', {
    state: () => {
        return {
            platformList: [],
            noticeList: [],
            gameLotteryList: [],
            lotteryCarouselList: [],
            allGameList: [],
            groupGameList: [],
        };
    },
    getters: {
        GetPlatformList: (state: LotteryState) => state.platformList,
        GetNoticeList: (state: LotteryState) => state.noticeList,
        getGameLotteryList: (state: LotteryState) => state.gameLotteryList,
        getLotteryCarouselList: (state: LotteryState) => state.lotteryCarouselList,
        getAllGameList: (state: LotteryState) => state.allGameList,
        getGroupGameList: (state: LotteryState) => state.groupGameList,
    },
    actions: {
        // 获取平台列表
        async handleGetPlatformList() {
            try {
                const result = await LotteryService.getPlatformList();
                if (result && result.code === 0) {
                    console.log(result.data, 'result.data------');
                    if (Array.isArray(result.data) && result.data?.length > 0) {
                        this.platformList = result.data;
                    } else {
                        this.platformList = [];
                    }
                    // HiCache.setCache<any>(HiStance.PLATFORM_LIST, this.platformList)
                    return result.code;
                }
                return result.code;
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 获取公告的列表
        async handleGetNoticeList(data?) {
            try {
                const result = await LotteryService.getNoticeList({ type: 1, ...data });
                console.log(result, 'result');
                if (result.code === 0) {
                    let newArr = [];
                    if (Array.isArray(result?.data) && result?.data?.length > 0) {
                        newArr = result?.data?.map(item => {
                            const { id, title, contents, status, opManager, isTop, type, uid, username, isRead, background } = item;
                            return {
                                ...item,
                                Id: id,
                                Title: title,
                                Contents: contents,
                                Status: status,
                                Op_Manager: opManager,
                                Is_Top: isTop,
                                Is_Read: isRead,
                                Type: type,
                                Uid: uid,
                                Username: username,
                                Background: background,
                                // Create_Time,
                                // Status_Label,
                                // Is_Top_Label,
                                // Type_Label,
                                // Short_Contents
                            };
                        });
                    } else {
                        newArr = [];
                    }
                    this.noticeList = newArr;
                    return {
                        code: result.code,
                        data: newArr,
                    };
                } else {
                    return result;
                }
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 查询所有彩种
        async handleGetAllLotteryTypeList() {
            try {
                console.log('6666');
                const result = await LotteryService.getAllLotteryTypeList();
                if (result.data && result.code === 0) {
                    // this.noticeList = result.data.DataList
                    console.log(result.data, 'result.data');
                    return result.data;
                }
                return result.code;
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 查询指定彩种下所有玩法
        async getLotteryGame(data) {
            try {
                const result = await LotteryService.getLotteryGame(data);
                if (result.data && result.code === 0) {
                    // this.noticeList = result.data.DataList
                    return result.data;
                }
                return result.code;
            } catch (e) {
                await Promise.reject(e);
            }
        },

        // 根据游戏获取玩法
        async getPlayInfo(data) {
            try {
                const result = await LotteryService.getPlayInfo({ gameId: data });
                if (result.data && result.code === 0) {
                    // this.noticeList = result.data.DataList
                    return result.data;
                }
                return result.code;
            } catch (e) {
                await Promise.reject(e);
            }
        },

        // 查询指定彩种下所有玩法
        async getOdds(data) {
            try {
                const result = await LotteryService.getLotteryGamePlay(data);
                if (result.data && result.code === 0) {
                    // this.noticeList = result.data.DataList
                    return result.data;
                }
                return result.code;
            } catch (e) {
                await Promise.reject(e);
            }
        },

        // 查询开奖信息列表
        async apiIssueResult(data) {
            try {
                const result = await LotteryService.getIssueResult(data);
                if (result.data && result.code === 0) {
                    // this.noticeList = result.data.DataList
                    return result.data;
                }
                return result.code;
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 根据游戏 获取当前期号
        async getIssue(data) {
            try {
                const result = await LotteryService.getLotteryOpenCode(data);
                if (result.data && result.code === 0) {
                    // this.noticeList = result.data.DataList
                    return result;
                }
                return result.code;
            } catch (e) {
                await Promise.reject(e);
            }
        },

        // 投注
        async getLotteryBetSubmit(data) {
            try {
                const result = await LotteryService.getLotteryBetSubmit(data);
                if (result.code === 0) {
                    // this.noticeList = result.data.DataList
                    return result;
                }
                return result.msg;
            } catch (e) {
                await Promise.reject(e);
            }
        },

        // 投注助手
        async apiHelper100(data) {
            try {
                const result = await LotteryService.getIssueResultHelper(data);
                if (result.data && result.code === 0) {
                    return result;
                }
                return result.msg;
            } catch (e) {
                await Promise.reject(e);
            }
        },

        // 获取最新开奖信息
        async apiGetNewest(data) {
            try {
                const result = await LotteryService.getNewOpenCode(data);
                if (result.data && result.code === 0) {
                    return result;
                }
                return result.msg;
            } catch (e) {
                await Promise.reject(e);
            }
        },
    },
});
